<template>
  <form id="frm_action">
    <div class="p-formgrid">
      <div class="col-6">
        <div class="p-card-field">
          <label class="p-col-fixed txt-right txt-required text-showroom1">Showroom</label>
          <div class="p-col">
            <InputText id="name" type="text" class="" v-model="obj_data.name" @Input="validateMaxlength" :maxlength="50"
              placeholder="Input (max: 50 charactors)" />
          </div>
        </div>
        <div class="p-card-field">
          <label class="p-col-fixed txt-right txt-required text-showroom1">Address</label>
          <div class="p-col css-showroom">
            <div class="p-inputgroup">
              <Textarea  v-model="obj_data.address" id="address" placeholder="Input (max: 500 charactors)" @Input="validateMaxlength" :maxlength="500"
                ></Textarea>
            </div>
          </div>
        </div>
        <div class="p-card-field">
          <label class="p-col-fixed txt-right text-showroom1">Manager</label>
          <div class="p-col css-showroom">
            <v-select :clearable="false" title="Property" class="" 
              placeholder="Choose" v-model="selectedUserManager" @search="searchAdmin" :options="listUser" :reduce="item => item.id"
              label="fullname">
              <span slot="no-options" @click="$refs.select.open = false">
                Empty data
              </span>
            </v-select>
            <input class="input_tmp_validator" id="manager_uid">
          </div>
        </div>
        <div class="p-card-field">
          <label class="p-col-fixed txt-right text-showroom1">Note</label>
          <div class="p-col">
            <Textarea id="note" type="text" class="" v-model="obj_data.note" :rows="5" @Input="validateMaxlength" :maxlength="2000"
              placeholder="Input (max: 2000 charactors)"></Textarea>
          </div>
        </div>

        <div class="p-card-field col-6">
          <label class="p-col-fixed txt-right text-showroom1">Order</label>
          <div class="p-col ">
            <InputNumber id="ordinal" type="text" class="" v-model="obj_data.ordinal"
              placeholder="0" />
          </div>
        </div>

        <div class="p-card-field ">
          <div class="p-col checkbox padding-avtive-css">
            <Checkbox v-model="obj_data.active" :binary="true" />
            <label class="p-col-fixed txt-right text">Active</label>
          </div>
        </div>
      </div>
      <Toolbar class="fixed-bottom-toolbar div-button">
        <template slot="right">
          <Button :label="$constants.TEXT_BUTTON.BACK" @click="backToList()" class="p-button-outlined button-back-black" id="back" />
          <Button v-if="mode == 'edit'" :label="$constants.TEXT_BUTTON.EDIT" @click="saveData()"
            class="main-style-button" />
          <Button v-else :label="$constants.TEXT_BUTTON.ADD" @click="saveData()" class="main-style-button" />
        </template>
      </Toolbar>
    </div>
  </form>
</template>
<script>
import DataServices from '@/core/DataServices';
import moment from "moment-timezone";
export default {
  components: {

  },
  props: {
    mode: String,
    model: Object,
  },
  data() {
    return {
      obj_data: {

      },
      dataBookingRound: [],
      selProperty: null,
      listProperty: [],
      listPropertyAll: [],
      from_to: null,
      address: null,
      start_booking_date: null,
      end_booking_date: null,
      partArr: [],
      time_zone_local: moment.tz.guess(true),
      componentKey: 0,
      listUser : [],
      users : [],
      selectedUserManager: null,
    }
  },
  watch: {

  },
  async mounted() {
    await this.getListUserActive();
    console.log("this.model:", this.model)
    if (this.model !== undefined && Object.keys(this.model).length > 0) {
      this.obj_data = this.model;
      this.selectedUserManager = this.obj_data?.manager_uid;
      console.log("this.obj_data:", this.obj_data);
      
      this.componentKey++;
    } else {
      this.obj_data = {
        active: true,
        ordinal: 1,
      };
      this.componentKey++;
    }
  },
  methods: {
    validateMaxlength(e) {
      if (e.target.value.length > e.target.maxLength) {
        e.target.value = e.target.value.slice(0, e.target.maxLength);
      }
    },
    async getListUserActive() {
      var listUid = [];
      this.users.map(m => listUid.push(m?.id));
      var where_key = {
        deleted: { _eq: false },
        role: { _eq: 'admin_child' },
        // is_verify_email: { _eq: true },
      }
      let { data } = await this.$apollo.query({
        query: DataServices.getList('users', { "fields": `id fullname email` }),
        variables: {
          where_key: where_key,
          orderBy: [{ created_at: 'desc' }]
        },
        fetchPolicy: "network-only"
      })
      var list = data[Object.keys(data)];
      var list_assign = [];
      for (let i = 0; i < list.length; i++) {
        const e = list[i];
        list_assign.push({ id: e.id, fullname: e.fullname , email : e.email});
      }
      this.listUser = list_assign;
      console.log("list_assign:", this.listUser);
    },

    async searchAdmin(search, loading) {
      console.log(loading);
      var listUid = [];
      this.users.map(m => listUid.push(m?.id));
      if (search !== '' && search !== null) {
        var where_key = {
          deleted: { _eq: false },
          role: { _eq: 'admin_child' },
          id: { _nin: listUid },
          _or: {
            fullname: { _iregex: this.$commonFuction.search(search) },
          }
        };
        let { data } = await this.$apollo.query({
          query: DataServices.getList('users', { "fields": `id fullname` }),
          variables: {
            where_key: where_key,
            orderBy: [{ created_at: 'desc' }]
          },
          fetchPolicy: "network-only"
        })
        var list = data[Object.keys(data)];
        var list_assign = [];
        // console.log("list===",list);
        for (let i = 0; i < list.length; i++) {
          const e = list[i];
          //if (!e?.booking?.id || (this.selProperty?.id && this.selProperty?.id == e.id)) {
          list_assign.push({ id: e.id, fullname: e.fullname });
          //}
        }
        this.listAdmin = list_assign;
      } else {
        // cosnole.log("dasdasd")
        this.listAdmin = this.listAdminAll;
      }
    },
    updateMatrix(data) {
      console.log(data);
      this.dataBookingRound = [...data];
    },
    async toCalendar() {
      this.$router.push(`/admin/list-booking?view=calendar&propery_id=${this.selProperty?.id}`);
    },
    async getListProperty() {

      var where_key = {
        deleted: { _eq: false },
        // booking: {id: {_is_null: true} },
      }
      let { data } = await this.$apollo.query({
        query: DataServices.getList('property', { "fields": `id code name address booking{id} part {id part order_booking user {id fullname email}}` }),
        variables: {
          where_key: where_key,
          orderBy: [{ created_at: 'desc' }]
        },
        fetchPolicy: "network-only"
      })
      var list = data[Object.keys(data)];
      var list_property = [];
      // console.log("list===",list);
      for (let i = 0; i < list.length; i++) {
        const e = list[i];
        if (!e?.booking?.id || (this.selProperty?.id && this.selProperty?.id == e.id)) {
          list_property.push({ id: e.id, name: e.name, code: e.code, address: e.address, part: e.part });
        }
      }
      this.listProperty = list_property;
      this.listPropertyAll = list_property;
    },

    async SearchProperty(search, loading) {
      console.log(loading);
      if (search !== '' && search !== null) {
        var where_key = {
          deleted: { _eq: false },
          // booking: {id: {_is_null: true} },
          _or: {
            _iregex: this.$commonFuction.search(search),
          }
        };
        let { data } = await this.$apollo.query({
          query: DataServices.getList('property', { "fields": `id code name address booking {id} part {id part order_booking user {id fullname email}}` }),
          variables: {
            where_key: where_key,
            orderBy: [{ created_at: 'desc' }]
          },
          fetchPolicy: "network-only"
        })
        var list = data[Object.keys(data)];
        var list_property = [];
        // console.log("list===",list);
        for (let i = 0; i < list.length; i++) {
          const e = list[i];
          if (!e?.booking?.id || (this.selProperty?.id && this.selProperty?.id == e.id)) {
            list_property.push({ id: e.id, name: e.name, code: e.code, address: e.address, part: e.part });
          }
        }
        this.listProperty = list_property;
      } else {
        // cosnole.log("dasdasd")
        this.listProperty = this.listPropertyAll
      }
    },
    backToList() {
      this.$emit('back');
    },
    async validateData() {
      this.validationErrors = {};
      const fieldsToValidate = [
        { id: "name", value: this.obj_data.name, maxLength: 50 },
        { id: "address", value: this.obj_data.address, maxLength: 500 },
        // { id: "manager_uid", value: this.selectedUserManager },
      ];
      let isFormInvalid = false;

      // Kiểm tra các trường chính
      for (let i = 0; i < fieldsToValidate.length; i++) {
        let field = fieldsToValidate[i];
        let inputElement = document.getElementById(field.id);

        if (inputElement && (inputElement.tagName === "INPUT" || inputElement.tagName === "TEXTAREA" || inputElement.tagName === "SELECT")) {
          if (this.$commonFuction.isEmptyObject(field.value)) {
            inputElement.setCustomValidity(this.$constants.MSG_TEXT.INPUT_INVALID_MSG);
            isFormInvalid = true;
          } else if (field.maxLength !== undefined && typeof field.value === 'string' && field.value.length > field.maxLength) {
            // Kiểm tra độ dài chỉ khi `field.value` là chuỗi
            inputElement.setCustomValidity(`The value cannot exceed ${field.maxLength} characters.`);
            isFormInvalid = true;
          } else if (field.minValue !== undefined && field.value <= field.minValue) {
            inputElement.setCustomValidity(this.$constants.MSG_TEXT.INPUT_INVALID_MSG);
            isFormInvalid = true;
          } else {
            inputElement.setCustomValidity("");
          }
        }
      }

      // Kiểm tra riêng cho trường `note` nếu có giá trị
      const noteElement = document.getElementById("note");
      if (noteElement) {
        const noteValue = noteElement.value;
        if (noteValue && noteValue.length > 2000) {
          noteElement.setCustomValidity("The note cannot exceed 2000 characters.");
          isFormInvalid = true;
        } else {
          noteElement.setCustomValidity(""); // Xóa lỗi nếu hợp lệ
        }
      }

      // Kiểm tra tính hợp lệ của toàn bộ form
      let inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity() || isFormInvalid) {
        inpObj.reportValidity();
        return true;
      }
      return false;
    },




    async saveData() {
      this.$commonFuction.is_loading(true);
      if (await this.validateData()) {
        this.$commonFuction.is_loading(false);
        return
      }
      
      var params = {
        name: this.obj_data?.name ?? '',
        address: this.obj_data?.address ?? '',
        manager_uid: this.selectedUserManager ?? '',
        note: this.obj_data?.note ?? '',
        ordinal: this.obj_data?.ordinal ?? '',
        active: this.obj_data?.active ?? false,
      }
      this.$emit('save', params)
    },
  },
}
</script>

<style lang="scss">
.p-formgrid {
   padding-top: 15px;
}
.main-style-button {
  background: #0086C4;
}
.p-multiselect {
  width: 450px;
}

.p-multiselect-label:not(.p-placeholder) {
  padding-top: .25rem;
  padding-bottom: .25rem;

}

.category-item-value {
  padding: .25rem .5rem;
  border-radius: 3px;
  display: inline-flex;
  margin-right: .2rem;
  background-color: var(--primary-color);
  color: var(--primary-color-text);
}

.p-multiselect-label-container {
  height: 40px;
}

.p-inputtext {
  margin: 0px 0px 0px 4px;
}

//style form add-edit
@media screen and (min-width: 1001px) {
  .input_distance {
    width: 728px !important;
  }
}

label.p-col-fixed txt-right {
  margin-bottom: 0px !important;
}

div.p-card-field {
  padding: 0px !important;
}

.p-col-fixed {
  padding: 0px !important;
  margin: 0px 0px 0px 9px !important;
}

.input_text {
  width: 760px !important;
  height: 48px !important;
}



.multiselect {
  width: 760px !important;
}



.vs__clear {
  display: none;
}

.input_width {
  width: 760px !important;
  height: 48px !important;
}

#distance {
  width: 1px !important;
  height: 48px !important;
  border-left: 0px;
  border-top: 0px;
  border: 1px solid #C8C8C8;
  border-radius: 0px;
  //border-top: none!important;
  //border: 1px solid rgba(60, 60, 60, 0.26);;
}

.manager-title {
  font-size: 24px !important;
}

.input-dif {
  margin-left: 5px !important;
  border-top: 0px;
}

.p-inputgroup-addon {
  height: 48px;
}


.p-col-fixed {
  padding: 0px !important;
  //margin:0px 0px 0px 10px !important;
}

label.p-col-fixed txt-right {
  margin-bottom: 0px !important;
}

div.p-card-field {
  padding: 0px !important;
}

.margin {
  margin-bottom: 12px !important;
}

.border_color {
  border: 1px solid #C8C8C8;
}

.text {
  font-weight: normal !important;
  margin-left: 15px !important;
}

.div_check {
  margin-top: 12px !important;
}


//responsive
@media screen and (max-width: 600px) {
  .input_width {
    width: 100% !important;
  }

  .div-button {
    padding: 8px !important;
  }

  #distance {
    text-align: left !important;
    padding: 6.8px;
    width: 100% !important;
  }

  .p-inputgroup-addon {
    margin-right: 12px;
  }

}

@media screen and (max-width: 1000px) {
  .input_width {
    width: 100% !important;
  }

  .div-button {
    padding: 8px !important;
  }

  .p-inputgroup-addon {
    margin-right: 12px;
  }

  #distance {
    text-align: left !important;
    padding: 6.8px;
  }
}

.p-button-outlined {
  .p-button-label {
    color: #FFDF01 !important;
  }
}
.p-col-fixed {
  font-weight: 700;
}



.p-button-outlined .p-button-label {
  color: #000000 !important;
}


.css-showroom {
  width: 100%;
  padding-left: 13px;
}

.p-card-field .text-showroom1 {
  padding-left: 5px !important;
}

.padding-avtive-css {
  padding-left: 10px !important;
}
</style>
